import { render, staticRenderFns } from "./bannerTab.vue?vue&type=template&id=1f42708e&scoped=true&"
import script from "./bannerTab.vue?vue&type=script&lang=js&"
export * from "./bannerTab.vue?vue&type=script&lang=js&"
import style0 from "./bannerTab.vue?vue&type=style&index=0&id=1f42708e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42708e",
  null
  
)

export default component.exports